import React, { act, useContext, useRef, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import './UserSetupMiniTabs.scss';
import * as label from '../../shared/util/label'
import { Card, Collapse } from 'react-bootstrap'
import EmployeeDetails from './EmployeeSetup/EmployeeDetails'
import { Row } from "react-bootstrap";
import { Button, Column, Checkbox } from "../../components";
import UserDetails from './UserSetup/UserDetails';
import { EmployeeContext } from './EmployeeContext'
import EmployeeSetupModel from '../model/EmployeeSetupModel'
import { useEffect } from 'react'
import * as constant from '../../shared/util/constant'
import { userSetupUtils } from '../utils/UserSetupUtils'
import UserDetailModel from '../model/UserDetailModel'
import { toast } from 'react-toastify';
import Logger from "../../shared/services/Logger";
import EntityHistoryView from './EmployeeSetup/EmployeeHistory';
import EmployeeSetupService from './service/EmployeeSetupService';
import { AbilityContext } from '../../shared/abilities/AbilityContext';

// import CustomerStandardFilterForm from '../../customer/filter/CustomerStandardSearch'

const UserSetupMiniTabs = (props) => {
    const ability = useContext(AbilityContext);
    const [employeeHistoryGridData, setEmployeeHistoryGridData] = useState([]);
    const [userHistoryGridData, setUserHistoryGridData] = useState([]);
    const [activeTab, setActiveTab] = useState('tab1');
    const [userHistoryTabAcsess, setUserHistoryTabAcsess] = useState<boolean>(false);
    const [empHistoryTabAcsess, setEmpHistoryTabAcsess] = useState<boolean>(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const employeeSetup: EmployeeSetupModel = {
        id: constant.DEFAULT_GUID,
        agencyGroupId: '',
        firstName: '',
        lastName: '',
        middleName: '',
        title: '',
        email: '',
        employeeStatusId: '',
        agencyId: '',
        legacyEmpCode: '',
        workPhone: '',
        workPhoneExt: '',
        countryCode: '',
        fullPartTimeIndId: constant.DEFAULT_GUID,
        empSupervisorCode: constant.DEFAULT_GUID,
        changedDate:'',
        enteredDate:'',
        changedByName:'',
        isActive:false

        // roleId: ''
    };
    const [employeeDetail, setEmployeeDetail] = useState(employeeSetup);
    const userSetup: UserDetailModel = {
        id: employeeDetail.id,
        firstName: '',
        lastName: '',
        email: '',
        roleId: '',
        objectId:'',
        isActive:false
    }
    const [userdetail, setUserDetail] = useState(userSetup);
    const employeeFormRef = useRef(null);

    const fetchEmployeeDetails = async (employeeId, setEmployeeDetail) => {       
        try {
            const employeeRes = await userSetupUtils.getEmployeeDetails(employeeId);
            setEmployeeDetail(employeeRes);

        } catch (error) {
            Logger.logError(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, error);
            toast.error(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    const fetchUserDetails = async (employeeId, setUserDetail) => {
        try {
            const userRes = await userSetupUtils.getUserDetails(employeeId);
            const baseUser = {
                id: employeeDetail.id,
                firstName: employeeDetail.firstName,
                lastName: employeeDetail.lastName,
                email: employeeDetail.email,
                roleId: '',
                objectId: '',
                isActive: false
            };
            setUserDetail(userRes ? userRes : baseUser);
            await fetchUserObjectId((userRes ? userRes.email : baseUser.email));
        } catch (error) {
            Logger.logError(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, error);
            toast.error(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    const fetchUserObjectId = async (email) => {
        try {
            const objectId = await userSetupUtils.getUserObjectIdByEmail(email);
            setUserDetail((prevState) => ({ ...prevState, objectId }));
        } catch (error) {
            Logger.logError(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, error);
            toast.error(constant.UserSetup.ERROR_EMPLOYEE_FETCH_DETAILS, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    useEffect(() => {    
         setActiveTab('tab1');
         
         if (ability.can('view', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.UserSetup.USER_SETUP_HISTORY) && ability.can('read', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.UserSetup.USER_SETUP_HISTORY))
            {
                setUserHistoryTabAcsess(true);
            } 

         if (ability.can('view', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.UserSetup.EMPLOYEE_SETUP_HISTORY) && ability.can('read', constant.ADMIN_HISTORY_ACCESS_GROUP, constant.UserSetup.EMPLOYEE_SETUP_HISTORY))
            {
                setEmpHistoryTabAcsess(true);
            } 

        if (!props.selectedEmployee) {
            setEmployeeDetail(employeeSetup);            
        } else {
            fetchEmployeeDetails(props.selectedEmployee, setEmployeeDetail);
        }
        // Increment refresh trigger to force updates even when same employee is selected
        setRefreshTrigger(prev => prev + 1);
    }, [props.selectedEmployee]);

    useEffect(() => {
      
        if (activeTab === "tab1" && employeeFormRef.current) {
            employeeFormRef.current.focus();
        }

        if (employeeDetail.id !== constant.DEFAULT_GUID) {
            if(activeTab === "tab1")
            {
                fetchEmployeeDetails(employeeDetail.id, setEmployeeDetail)
            }
            else if(activeTab === "tab3")
                fetchUserDetails(employeeDetail.id, setUserDetail);
        }
    }, [activeTab, employeeDetail.id, refreshTrigger]);

    const history = useHistory();

    const handleTabChange = (tab: string) => {        
        if(tab == 'tab3' && employeeDetail.id == constant.DEFAULT_GUID) {
            toast.warn("Please create an employee before accessing the User Setup tab.", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else if ((tab == 'tab2') && employeeDetail.id == constant.DEFAULT_GUID) {
            toast.warn('Please select or create an employee to view history.', { position: toast.POSITION.TOP_RIGHT });
        }
        else if ((tab == 'tab2' || tab == 'tab4') && employeeDetail.id !== constant.DEFAULT_GUID) {
            setActiveTab(tab);
             const EmployeeSetupServiceInstance = new EmployeeSetupService();
            // Fetch history for the selected tab          
            if(tab === 'tab2') {
                EmployeeSetupServiceInstance.getEmployeeHistory(employeeDetail.id).then(setEmployeeHistoryGridData);
            } else if(tab === 'tab4') {
                EmployeeSetupServiceInstance.getUserHistory(employeeDetail.id).then(setUserHistoryGridData);
            }
        }
        else {
            setActiveTab(tab);
        }
    };

    return (
        <EmployeeContext.Provider value={employeeDetail}>
            <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
                <Nav variant="tabs" className="miniTabs">
                    <Nav.Item>
                        <Nav.Link eventKey="tab1">{label.EMPLOYEE_SETUP}</Nav.Link>
                    </Nav.Item>
                    {empHistoryTabAcsess && (
                        <Nav.Item>
                            <Nav.Link eventKey="tab2">{label.HISTORY_TAB}-Employee Setup</Nav.Link>
                        </Nav.Item>
                    )}
                    <Nav.Item>
                        <Nav.Link eventKey="tab3">{label.USER_SETUP}</Nav.Link>
                    </Nav.Item>
                     {userHistoryTabAcsess && (
                    <Nav.Item>
                      <Nav.Link eventKey="tab4">{label.HISTORY_TAB}-User Setup</Nav.Link>
                    </Nav.Item>
                     )}
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="tab1" className="tabContent">
                        {<EmployeeDetails
                            setOpen={props.setOpen} employeeDetail={employeeDetail} loadDataFlag={props.loadDataFlag}
                            setEmployeeDetail={setEmployeeDetail}
                            firstNameRef={employeeFormRef}
                        />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="tab2" className="tabContent">
                        {employeeDetail.id !== constant.DEFAULT_GUID && (
                            <EntityHistoryView setOpen={props.setOpen} loadDataFlag={props.loadDataFlag} historyGridData={employeeHistoryGridData} fileName="History-Employee Setup.csv"/>
                        )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="tab3" className="tabContent">
                        {<UserDetails
                            setOpen={props.setOpen} userdetail={userdetail} loadDataFlag={props.loadDataFlag}
                            setUserDetail={setUserDetail}/>}
                    </Tab.Pane>
                     <Tab.Pane eventKey="tab4" className="tabContent">
                        {employeeDetail.id !== constant.DEFAULT_GUID && (
                            <EntityHistoryView setOpen={props.setOpen} loadDataFlag={props.loadDataFlag} historyGridData={userHistoryGridData} fileName="History-User Setup.csv"/>
                        )}
                     </Tab.Pane>
                </Tab.Content>

            </Tab.Container>

        </EmployeeContext.Provider>

    );
};

export default UserSetupMiniTabs;